export default {
  title: 'Carrito',
};
